<template>
    <div class="text-center bg-primary mt-5">
        <hr class="footer">
        <div class="mt-5">
             <div class="row">
                    <a class="col-sm-3 text-white" href="https://www.leroymerlin.fr/services/service-client/retrait-magasin-et-retrait-2h.html" ><div><font-awesome-icon icon="stopwatch" /><br /><span class='text-center font-weight-bold'></span>Retrait gratuit en magasin*</div></a>
                    <a class="col-sm-3 text-white" href="https://www.leroymerlin.fr/services/service-client/livraison-a-domicile.html" ><div><font-awesome-icon icon="truck" /><br /><span class='text-center font-weight-bold'></span>Livraison à domicile*</div></a>
                    <a class="col-sm-3 text-white" href="https://www.leroymerlin.fr/services/service-client/retour-remboursement.html" ><div><font-awesome-icon icon="retweet" /><br /><span class='text-center font-weight-bold'></span>Retrait gratuit en magasin*</div></a>
                    <a class="col-sm-3 text-white" href="https://www.leroymerlin.fr/services/service-client/retour-remboursement.html" ><div><font-awesome-icon icon="smile-beam" /><br /><span class='text-center font-weight-bold'></span>Retrait gratuit en magasin*</div></a>
                </div>
                <a href="https://www.plus-que-pro.fr/"  class="btn btn-primary">PLUS QUE PRO</a>
        </div>
        <div class="card-footer text-muted "> </div>
    </div>
</template>
<script>
export default {
    name: 'Footer',
}
</script>

<style lang="fr">
    
</style>